//this is ES6 syntax, it's essentially equivalent to: var React = require('react')
import React from 'react';
import { reduxForm, Field } from 'redux-form'; // imported Field

//Controls
import Controls from 'utils/renderControl.js';

//Validation function
import validate from './validate';

class Complete extends React.Component {
  constructor(props) {
    super(props);
  }

  //now this component is getting passed props from the AppContainer
  static propTypes = {
    config: React.PropTypes.object,
    location: React.PropTypes.object,
    onSubmit: React.PropTypes.func,
  };

  componentDidMount() {
    console.log(this.props);
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, invalid, errors } =
      this.props;

    return (
      <form id="complete" className="complete">
        <h2>Complete</h2>
        {/************************
         * MOBILE - PREVIOUS/NEXT
         *************************/}
        <div className="actions-mobile clearfix visible-xs-block">
          <a
            disabled={submitting}
            className="prev"
            onClick={this.props.goToPrevious}
          >
            <i className="fa fa-chevron-left" aria-hidden="true"></i> Previous
          </a>
        </div>

        <h3>Please read carefully and sign below:</h3>
        <p style={{ fontSize: '14px' }}>
          I certify with my signature below that all of the facts and statements
          as set forth in this employment application are true and complete. I
          understand and agree that if employed, any falsification or omission
          of information shall be considered grounds for immediate dismissal.
        </p>
        <p style={{ fontSize: '14px' }}>
          I hereby authorize you to conduct a full investigation of my personal,
          educational and employment history through the use of whatever
          investigative agencies or bureaus you may choose. I also specifically
          authorize you to contact my PREVIOUS employers and authorize them to
          provide any information or references that you deem necessary in
          connection with this application.
        </p>
        <p style={{ fontSize: '14px' }}>
          It is unlawful in Massachusetts to require or administer a lie
          detector test as a condition of employment or continued employment. An
          employer who violates this law shall be subject to criminal penalties
          and civil liability.
        </p>
        <p style={{ fontSize: '14px' }}>
          I understand that no verbal promises or guarantees relating to
          employment are binding upon the Company and that, if employed I will
          be an employee "at will" and may be terminated at any time. If I am
          employed, I agree to abide by the Company's rules and regulations and
          any changes thereto.
        </p>
        <p style={{ fontSize: '14px' }}>
          The Company is committed to a policy of equal opportunity employment
          and non-discrimination in all aspects of employment, including
          recruitment, hire, placement, promotion, termination, layoff, recall,
          transfer, leaves of absence, compensation and training. Employment
          decisions are based on merit, competence, performance, and the
          Company’s business needs. We do not discriminate against employees or
          applicants for employment on the basis of their, race (including
          traits historically associated with race, such as hair texture ),
          color, religious creed, sex, age (40 and over), gender, gender
          identity and/or expression, pregnancy (including childbirth,
          lactation, and related medical conditions), paternity status, marital
          status, national origin or ancestry, physical and/or mental
          disability, genetic information (including atypical hereditary
          cellular or blood trait testing), HIV status, active military and/or
          veteran status, certain criminal records, any other characteristics
          protected by federal, state or local law. The Company does not
          tolerate discrimination or harassment based on any of these
          characteristics and is committed to providing a working environment
          for employees that is free from all forms of discrimination and
          unlawful conduct that is coercive, disruptive, retaliatory or
          harassing, including sexual harassment.
        </p>

        {/************************
         * DISCLAIMER
         *************************/}
        <div
          dangerouslySetInnerHTML={{ __html: this.props.config.disclaimer }}
        ></div>

        {/************************
         * SIGNATURE
         *************************/}
        <div className="row">
          <Field
            name="electronicSignature"
            type="text"
            component={Controls.input}
            placeholder="Type your full name here."
            label="Enter electronic Signature"
            wrapperClassName="col-sm-12 required"
          />
        </div>

        {/************************
         * RECAPTCHA/WHOLE FORM VALIDATION
         *************************/}
        {errors.pages && errors.pages.length ? (
          <div className="alert alert-danger">
            <h3>Some fields are missing on the following pages:</h3>
            <ul>
              {errors.pages.map((error) => (
                <li key={error.label}>
                  <a href={`${error.url}?validate=true`}>{error.label}</a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="recaptcha">
            <Field name="recaptcha" component={Controls.recaptcha} />
          </div>
        )}

        {/************************
         * PREVIOUS/NEXT
         *************************/}
        <div className="actions">
          <button
            type="submit"
            disabled={submitting || invalid}
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'employment-application',
  destroyOnUnmount: false,
  validate,
})(Complete);
